import { gql } from "@apollo/client";

export const GET_HUBS = gql`
  query getHubs($storeId: String!) {
    hubs(storeId: $storeId) {
      edges {
        node {
          id
          pk
          slug
          name
          description
          image(size: "120x120", method: "thumbnail_webp") {
            url
            alt
          }
        }
      }
    }
  }
`;

export const GET_HUB = gql`
  query getHub($storeId: String!, $slug: String) {
    hub(storeId: $storeId, slug: $slug) {
      id
      pk
      slug
      name
      description
      image(size: "120x120", method: "thumbnail_webp") {
        url
        alt
      }
    }
  }
`;
